import nameSort from './nameSort';

export function positionComparator(a, b) {
  const posA = a?.position;
  const posB = b?.position;
  const hasPosA = typeof posA === 'number' && !isNaN(posA);
  const hasPosB = typeof posB === 'number' && !isNaN(posB);

  if (hasPosA && hasPosB) return posA - posB;
  if (hasPosA) return -1;
  if (hasPosB) return 1;
  return nameSort(a?.title, b?.title);
}

export default function sortByPosition(items) {
  return [...items].sort(positionComparator);
}
